export const GET_CODES_LIST = "GET_CODES_LIST"
export const GET_CODES_LIST_SUCCESS = "GET_CODES_LIST_SUCCESS"
export const GET_CODES_LIST_FAILED = "GET_CODES_LIST_FAILED"

export const GET_CODE_BATCH = "GET_CODE_BATCH"
export const GET_CODE_BATCH_SUCCESS = "GET_CODE_BATCH_SUCCESS"
export const GET_CODE_BATCH_FAILED = "GET_CODE_BATCH_FAILED"

export const RETRY_BATCH = "RETRY_BATCH"
export const RETRY_BATCH_SUCCESS = "RETRY_BATCH_SUCCESS"
export const RETRY_BATCH_FAILED = "RETRY_BATCH_FAILED"

export const OPEN_ASSIGN_CODE_MODAL = "OPEN_ASSIGN_CODE_MODAL"
export const HIDE_ASSIGN_CODE_MODAL = "HIDE_ASSIGN_CODE_MODAL"

export const OPEN_CREATE_USER_MODAL = "OPEN_CREATE_USER_MODAL"
export const HIDE_CREATE_USER_MODAL = "HIDE_CREATE_USER_MODAL"

export const ADD_NEW_USER = "ADD_NEW_USER"
export const ADD_NEW_USER_SUCCESS = "ADD_NEW_USER_SUCCESS"
export const ADD_NEW_USER_FAILED = "ADD_NEW_USER_FAILED"
export const RESET_CREATED_USER = "RESET_CREATED_USER"

export const OPEN_REASSIGN_CODE_MODAL = "OPEN_REASSIGN_CODE_MODAL"
export const HIDE_REASSIGN_CODE_MODAL = "HIDE_REASSIGN_CODE_MODAL"

export const OPEN_REINSTATE_CODE_MODAL = "OPEN_REINSTATE_CODE_MODAL"
export const HIDE_REINSTATE_CODE_MODAL = "HIDE_REINSTATE_CODE_MODAL"

export const ASSIGN_CODE = "ASSIGN_CODE"
export const ASSIGN_CODE_SUCCESS = "ASSIGN_CODE_SUCCESS"
export const ASSIGN_CODE_FAILED = "ASSIGN_CODE_FAILED"

export const REINSTATE_CODE = "REINSTATE_CODE"
export const REINSTATE_CODE_SUCCESS = "REINSTATE_CODE_SUCCESS"
export const REINSTATE_CODE_FAILED = "REINSTATE_CODE_FAILED"

export const REASSIGN_CODE = "REASSIGN_CODE"
export const REASSIGN_CODE_SUCCESS = "REASSIGN_CODE_SUCCESS"
export const REASSIGN_CODE_FAILED = "REASSIGN_CODE_FAILED"

export const GENERATE_CODE = "GENERATE_CODE"
export const GENERATE_CODE_SUCCESS = "GENERATE_CODE_SUCCESS"
export const GENERATE_CODE_FAILED = "GENERATE_CODE_FAILED"

export const DELETE_BATCH = "DELETE_BATCH"
export const DELETE_BATCH_SUCCESS = "DELETE_BATCH_SUCCESS"
export const DELETE_BATCH_FAILED = "DELETE_BATCH_FAILED"
